import React from "react";
import { useAuth } from "../../../../../context/AuthContext";
import "./AccountTab.css";

/**
 * AccountTab component that displays user account information and logout button
 * Now uses the AuthContext directly instead of receiving props
 */
const AccountTab = () => {
  // Get auth data from context
  const { userInfo, userRole, logout } = useAuth();

  return (
    <div className="account-section">
      <div className="user-profile">
        <h2>Account Settings</h2>
        {userInfo && (
          <div className="account-details">
            <p className="account-email">
              <strong>Email:</strong> {userInfo.email}
            </p>
            <p className="account-role">
              <strong>Role:</strong> {userRole}
            </p>
          </div>
        )}
        <button onClick={logout} className="logout-btn">
          Logout
        </button>
      </div>
    </div>
  );
};

export default AccountTab;
